var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4141 28.3613C17.0662 29.7522 15.7737 30.8056 14.2002 30.8057C12.6266 30.8057 11.3343 29.7522 10.9863 28.3613H17.4141ZM14.2002 0.75C14.9263 0.750102 15.4785 1.31748 15.4785 1.97266C15.4785 2.01306 15.4766 2.0528 15.4727 2.0918L15.4043 2.77148L16.0742 2.90332C20.3782 3.74837 23.5926 7.43882 23.5928 11.833C23.5928 12.9763 23.8537 15.9886 24.4971 18.9668C24.8193 20.4585 25.2436 21.971 25.793 23.25C26.0436 23.8336 26.3322 24.3937 26.6641 24.8887H1.73633C2.06811 24.3938 2.35581 23.8335 2.60645 23.25C3.1558 21.971 3.58006 20.4585 3.90234 18.9668C4.54577 15.9886 4.80762 12.9763 4.80762 11.833C4.80778 7.43885 8.0222 3.7484 12.3262 2.90332L12.9961 2.77148L12.9277 2.0918C12.9238 2.0528 12.9219 2.01309 12.9219 1.97266C12.9219 1.31742 13.474 0.75 14.2002 0.75Z",
    stroke: "#121212",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.b33b0136da478539019730b2637f4612.svg";
export { ForwardRef as ReactComponent };